import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";
import { Grid, GridItem } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { Form } from "@domestika-dev/prudencio/dist/atoms/Form";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography";
import { useLanguagesList } from "../../customHooks/useLanguagesList";

export const LiveSessionScheduleLanguageInput = ({
  disabled,
  value,
  hasError,
  errorMessage,
  errorMessageValues,
  onChange,
}) => {
  const intl = useIntl();
  const { getLanguagesList } = useLanguagesList();

  const getErrorMessage = () =>
    intl.formatMessage(
      {
        id: errorMessage,
      },
      errorMessageValues
    );

  return (
    <GridItem gridRow={5} gridColumn="1 / span 8" marginTop={6}>
      <Grid gridRowGap={0} style={{ justifyContent: "space-between" }}>
        <GridItem gridRow="1" gridColumn="1 / span 8">
          <Text
            as="label"
            htmlFor="liveSessionLanguage"
            size="tiny"
            marginBottom={2}
            display="block"
          >
            <FormattedMessage id="live_sessions.schedule_new.language_input.label" />
          </Text>
          <Form.Select
            size="medium"
            id="liveSessionLanguage"
            name="liveSessionLanguage"
            selected={value}
            hasError={hasError}
            disabled={disabled}
            placeholderMessage={intl.formatMessage({
              id: "live_sessions.schedule_new.language_input.placeholder",
            })}
            onSelected={({ value: selectedValue }) => onChange(selectedValue)}
            options={getLanguagesList()}
          />
        </GridItem>
        {errorMessage && (
          <GridItem gridRow="2" gridColumn="1 / span 8">
            <Form.Error textAlign="left">{getErrorMessage()}</Form.Error>
          </GridItem>
        )}
      </Grid>
    </GridItem>
  );
};

LiveSessionScheduleLanguageInput.propTypes = {
  disabled: PropTypes.bool,
  value: PropTypes.string,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  /* eslint-disable-next-line react/forbid-prop-types */
  errorMessageValues: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

LiveSessionScheduleLanguageInput.defaultProps = {
  disabled: false,
  value: "",
  hasError: false,
  errorMessage: "",
  errorMessageValues: {},
};

export default LiveSessionScheduleLanguageInput;
